import { render } from "./addpet.vue?vue&type=template&id=12f57fab"
import script from "./addpet.vue?vue&type=script&lang=js"
export * from "./addpet.vue?vue&type=script&lang=js"

import "./addpet.vue?vue&type=style&index=0&id=12f57fab&lang=scss&Scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__